<template>
	<div class="page">
		<div v-if="!phrase">
			Wpisz szukaną frazę
			
		</div>
		
		<template v-else>
			<div class="d-flex justify-content-between align-center mb-3">
				<div class="font-weight-bold grey--text text--darken-1">
					Wyniki wyszukiwania dla “{{ phrase }}”
				</div>
				<div class="d-flex">
<!--							Filtruj wyniki: <pre>dropdown</pre>-->
				</div>
			</div>
			<v-skeleton-loader
				v-if="postsLoading"
				type="card"
				class="mt-3"
			></v-skeleton-loader>
			<search-results-posts v-else v-model="posts" />
			<v-skeleton-loader
				v-if="groupsLoading"
				type="card"
				class="mt-3"
			></v-skeleton-loader>
			<v-card v-if="groups && groups.length > 0" flat outlined class="wall-card mt-3">
				<v-card-title>Grupy</v-card-title>
				<v-card-text>
					<template v-for="(group, i) in groups">
						<search-results-group :group="group" :key="'group-main-search-result-' + group.id" class="my-5"/>
						<v-divider :key="i" v-if="i != groups.length - 1" />
					</template>
				</v-card-text>
			</v-card>
			<v-skeleton-loader
				v-if="usersLoading"
				type="card"
				class="mt-3"
			></v-skeleton-loader>
			<v-card v-if="users && users.length > 0" flat outlined class="wall-card mt-3">
				<v-card-title>Osoby</v-card-title>
				<v-card-text>
					<template v-for="(user, i) in users">
						<search-results-user :user="user" :key="'users-main-search-result-' + user.id" class="my-3" />
						<v-divider :key="i" v-if="i != users.length - 1" />
					</template>
				</v-card-text>
			</v-card>
		</template>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import SearchResultsGroup from "@/components/search/SearchResultsGroup";
import SearchResultsUser from "@/components/search/SearchResultsUser";
import SearchResultsPosts from "@/components/search/SearchResultsPosts";
export default {
	name: "SearchResults",
	components: {
		SearchResultsGroup,
		SearchResultsUser,
		SearchResultsPosts,
	},
	data () {
		return {
			posts: null
		}
	},
	computed: {
		...mapGetters({
			phrase: "searcher/phrase",
			users: "searcher/users",
			comments: "searcher/comments",
			groups: "searcher/groups",
			problemIdeas: "searcher/problemIdeas",
			notes: "searcher/notes",
			postsLoading: "searcher/postsLoading",
			groupsLoading: "searcher/groupsLoading",
			commentsLodaing: "searcher/commentsLodaing",
			usersLoading: "searcher/usersLoading",
			problemIdeasLoading: "searcher/problemIdeasLoading",
			notesLoading: "searcher/notesLoading",
		}),
		allLoading() {
			return this.postsLoading || this.groupsLoading || this.usersLoading;
		}
	},
}
</script>

<style scoped>

</style>
